module.exports = __webpack_public_path__ + "img/dayin.a7dab546.png";